import EventDetailsPage from './EventDetailsPage'

export default EventDetailsPage
// eslint-disable-next-line import/export
export * from './EventDetailsPage'
